import { Company } from "@/api/company-api";
import CompanyFilterCondition from "./group-filter-condition";

// TODO: サーバーの工数の関係で手元でやってた。サーバーに移した方がいい。

export default class CompanyFilter {
  public constructor(private condition: CompanyFilterCondition) {}

  public isSatisfied(company: Company) {
    const a = new CompanyQueryFilter(this.condition.query || "");
    const b = new CompanyRoleFilter(this.condition.role);
    return a.isSatisfied(company) && b.isSatisfied(company);
  }
}

class CompanyQueryFilter {
  public constructor(private query: string) {}

  public isSatisfied(company: Company) {
    if (!this.query) return true;
    return company.name.includes(this.query);
  }
}

class CompanyRoleFilter {
  public constructor(private role: string) {}

  public isSatisfied(company: Company) {
    if (this.role === "vendor") {
      return company.vendor;
    }
    if (this.role === "client") {
      return company.client;
    }
    return true;
  }
}
